module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_vm._v("Dramatis Personae")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('img', {
    attrs: {
      "alt": "img4.png",
      "src": "Images/img4.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t8"
  }, [_vm._v("HEAVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("Michael: Chief Archangel, he is oldest of the Archangels and has the following titles: Prince of Heaven, Archangel of Repentance, Righteousness, Mercy, and Sanctification, Tutelary Sar of Israel, Guardian of Jacob, Commander in Chief of the Armies of Heaven, Destroyer of Satan, Chief of the Sun, patron saint of policemen, a Grail Angel. His power is gold, and he is bonded to Archangel Gabriel.")])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Gabriel: Archangel of War, he is next in age and has the following titles: Mercy, Revelation, and Annunciation, the Strength of God, God’s Rage and Jealousy, General of God’s Armies, Commander of the Seraphim, Left Hand of God, Destroyer of Sodom and Gomorrah, Dictator of the Koran to Mohammed, Chief of the Moon, a Grail Angel. His power is silver, and he is bonded to Archangel Michael.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Raphael: Archangel of Healing and Medicine, Prayer, Joy and Light, Overseer of the Evening Winds, Angel of the Sun. His power is white, and he is bonded to Israfel, Angel of Music.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("Uriel: Archangel of Sanctification, Fire, and Vengeance, and his titles are: Guardian of the Gates of Hell, Guardian of Eden, Fire of God, Angel of Thunder. His power is orange, and he is bonded to Archangel Raziel.")])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Tzadkiel: Archangel of Judgment, and his titles are: Chief of God’s Secret Police, Commander of the Ophanim, Angel of Jupiter. His power is copper colored.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Samael: Archangel of Death. His power is indigo.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Remiel: Archangel of Mercy and Visions, and his titles are: Guide to Judgment, Angel of Thunder. His power is dark green, and he is in a long-term relationship with Ishtahar.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Haniel: Archangel of Love, with the titles of: Guardian of Innocents, Angel of Venus. His power is red.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("Metatron: Archangel of the Voice of God, and his titles are: Angel of the Covenant, Chancellor of Heaven, Scribe of God. His power is pale blue.")])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Raziel: Archangel of Secrets and Mysteries and Science, Author and Keeper of the "), _c('span', {
    staticClass: "t7"
  }, [_vm._v("Sefer Raziel")]), _vm._v(" book of magic, Angel of the Grail. His power is bronze, and he is bonded to Archangel Uriel.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Israfel: Angel of Music. His power is blue, and he is bonded to Archangel Raphael.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Tabbris: Angel of Free Will. His power is purple.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("Agrat bat Mahlat: Angel of Prostitution, Sex, and Procreation. She is one of the four Holy Succubi, called the Whore of God. Her power is red, and she is married/bonded to Shateiel, Angel of Silence and Soldiers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Shateiel: Angel of Silence and Soldiers. The most trusted lieutenant of Gabriel, he is mute, communicates solely by telepathy. His power is light blue, and he is married/bonded to Agrat, Angel of Prostitution, Sex, and Procreation.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Camael: An Angel of War under the command of Gabriel. His power is silver-blue.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Sophiel: Intelligence of Jupiter (corresponding to Tzadkiel), Angel of the Moon. Her power is blue.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Brieus: Angel of Demon Hunting. His power is silver-blue.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t8"
  }, [_vm._v("EARTH")])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Bob Taytton: Megalomaniac who believed himself to be the reincarnation of a French saint named Secaire. Opened the portals to Hell that sparked the Seventy Years War, and was killed at the outset of that war.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Ishtahar: High Priestess of Semjaza, Prince of the Grigori. Born in the city of Eden at the dawn of Creation. Forced to bear children to Semjaza, mother of the first Nephilim—half-human, half-angel hybrids. She is in a long-term relationship with Remiel.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Hiwa: Elder son of Ishtahar, hates his father, Semjaza and feels nothing but loathing for him. Has spent most of his life living as an assassin, working predominantly for the Russian mafia.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Ahijah: Younger son of Ishtahar, also hates his father, Semjaza. Has devoted his life to God, living and working as a priest, finally settling in Brazil.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Eleanora: A French witch, living in Provence.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Lyudmila: Queen of the Eastern Bloc Weres and has two shifter shapes—a wolf and a mink. Has talent with magic and with visions. Is Russian but now lives in Yerevan, capital of Armenia.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Piotr: Lyudmila’s consort. Is Russian, but lives in Yerevan with Lyudmila. His shifter shape is that of an eagle.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("Minnie: An Australian witch. Formerly a thief, known as No-Hands Minnie.")])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Max/Mobius: Extremely talented hacker known for being able to dig up hidden information. His partner is Minnie. He lives with her and their cat.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("Angelique: Alpha of a Venatores pack. Formerly US Air Force and is of Mexican descent, raised in Texas. Her shifter shape is a dark gray wolf.")])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Lily: Beta of Angelique’s pack, is an Englishwoman, formerly of the British Army. Her shifter is a gray wolf, and she is married to Danny, another member of the pack.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Baxter: Kappa of Angelique’s pack. Formerly a US Marine, suffering PTSD. His shifter shape is an Arctic white wolf.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Danny: Kappa of Angelique’s pack. Also a former US Marine, born and raised in Georgia. His shifter shape is a gray wolf, and he is married to Lily, another member of the pack.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Riley: Omega of Angelique’s pack and the pack medic. Formerly a US Navy Corpsman working with the United States Marine Corps. His shifter shape is a red rock wolf.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Declan Jones: Shifter and older brother of Liam. Raised in Puerto Rico, worked for some years in the US Army.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("Liam Jones: Necromancer and younger brother of Declan. Worked as a police officer before he and Declan set out together to work as demon trackers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t8"
  }, [_vm._v("HELL")])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Lucifer: King of Hell. A Fallen Angel, the first Fallen Angel. Is very good friends with the Archdemon Adramelek, one of the first angels to Fall. His titles are: King of Hell, Lightbringer, The Morningstar, Lucifer, Prince of Lies, Lord of Deceit, Lord of the Flies, The Devil, Satan. Is almost omniscient, nearly as much as God. His power is white, and he is in an open relationship with Lilith and is sometimes involved with Adramelek.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Adramelek: Fallen Angel and unquestionably loyal to Lucifer. Formerly a member of the choir of angels called the Thrones. His titles are: Archdemon of Fire, Great Minister and Chancellor of the Order of the Fly, President of Satan’s Private Council, the High Council of Devils, President of the Order of Glass Knives. Power is silver-black. He is Lucifer’s sometime lover.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Ondrass: One of the first demons created, born out of Lucifer’s fury just after his fall into Hell. His titles are: Archdemon of Discord, Grand Marquis of Hell, Lucifer’s personal hit man, member of the Order of Glass Knives. His power is black, and he is in a relationship with his personal assistant, Markus.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Melcherisa: Archdemon of Darkness, Governor of the Base Natures of Hell, member of the Guild of Glass Knives. His power is dark gray.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Lix Tetrax: Duchess of Whirlwinds, High Priestess of Fevers, member of the Order of the Fly, member of the Guild of Knives. Her power is silver-gray.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Ba’al: Seneschal to Lucifer and butler to Lucifer. Absolutely loyal to Lucifer and loves him as a father figure. His power is gray.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Sprite: Adramelek’s hell-cat, ginger colored, with a fondness for tuna and fresh fish.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Uphir: Archdemon of Medicine and Science, Hell’s Physician. His power is muddy brown.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Markus: Personal Assistant to Ondrass, the Archdemon of Discord. His power is gray, and he is in a relationship with Ondrass.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Lilith: The first wife of Adam, and prior to that, the consort of God Himself, Lilith is the first scorned woman and the first strong woman to say no to a man. After she left Adam, she wandered in the wilderness and mothered giants, the monsters of ancient mythology. Originally named Lilitu, she met Lucifer in the desert and they spent a long time in conversation. Lilith is the oldest of the four sisters of the succubi. Agrat, Eisheth, and Naamah are her sisters. Her titles are: Consort of Lucifer, Eater of Infants, The First Adulteress, Consort of Yahweh, Mother of Giants.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Her power is red.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t8"
  }, [_vm._v("OTHER")])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Semjaza: Prince of the Grigori, imprisoned in the constellation of Aquila by Gabriel in the last days of Eden. His punishment was for corrupting humanity and breeding with human women, most notably his high priestess, Ishtahar, whom he forced to be his wife. Is the father of Hiwa and Ahijah. He is a talented magician. Was pulled down to Hell and now suffers in the Lake of Frozen Souls, tortured personally by Lucifer.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Naamah: One of the Four Succubi Sisters, she used to live in the seas of the Earth, but moved to Purgatory during the Seventy Years War. Has two children, twins, whose father is unknown. Her twin children are named Arthur and Morgana, after the Arthurian legends.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47dfb4e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/007.vue
// module id = 72
// module chunks = 0